{
    "BILLED": "Facturé",
    "CANCELLED": "Annulé",
    "COMPLETED": "Terminé",
    "LOST": "Perdu",
    "OPEN": "Ouvert",
    "OPEN_IN_PICKING": "Ouvert en prépa.",
    "OTHER": "Autre",
    "PARTIALLY_BILLED": "Part. facturé",
    "PARTIALLY_PICKED": "Part. préparé",
    "PARTIALLY_RECEIVED": "Part. reçu",
    "PARTIALLY_SHIPPED": "Part. livré",
    "PENDING": "En attente",
    "PICKED": "Préparé",
    "PROCESSED_INTERNALLY": "Traité en interne",
    "RECEIVED": "Reçu",
    "RELEASED_FOR_BILLING": "Prêt à facturer",
    "RELEASED_FOR_DELIVERY": "Prêt à livrer",
    "RETURNED": "Retourné",
    "REVISED": "Révisé",
    "SHIPPED": "Livré",
    "UNKNOWN": "Inconnu",
    "WON": "Gagné"
}
